import React from "react";

type ReplyIconProps = {
  className?: string;
  onClick?: () => void;
  size?: string;
  color?: string;
};

const ReplyIcon = ({ size = "16", className, onClick, color = '#373F51' }: ReplyIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M4.75391 12.2067H10.0872C11.9272 12.2067 13.4206 10.7134 13.4206 8.87337C13.4206 7.03337 11.9272 5.54004 10.0872 5.54004H2.75391"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.28674 7.20655L2.58008 5.49988L4.28674 3.79321"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReplyIcon;
